export class BaseExploreFilterParser {
    baseFilterParser;
    constructor(baseFilterParser) {
        this.baseFilterParser = baseFilterParser;
    }
    getMetadata(filter, negate) {
        return this.baseFilterParser.getMetadata(filter, negate, null);
    }
    getFilter(filter, negate) {
        throw new Error('MUST OVERRIDE');
    }
    getElasticFilter(filter) {
        throw new Error('MUST OVERRIDE');
    }
}
//# sourceMappingURL=base.js.map